import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { doc, getDoc, collection, onSnapshot, query } from 'firebase/firestore'
import { db } from '../../../../firebase'
import Header from '../../Header/Header'
import './freecourses.css'

function FreeCourseDetails() {
  const { courseId } = useParams()
  const [course, setCourse] = useState(null)
  const [lessons, setLessons] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadCourse = async () => {
      const snap = await getDoc(doc(db, 'courses', courseId))
      if (snap.exists()) setCourse({ id: snap.id, ...snap.data() })
      setLoading(false)
    }
    loadCourse()
  }, [courseId])

  useEffect(() => {
    const q = query(collection(db, 'courses', courseId, 'lessons'))
    const unsub = onSnapshot(q, (snapshot) => {
      const lessonsData = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
        files: d.data()?.files || [],
      }))
      lessonsData.sort((a, b) => (a.order ?? 9999) - (b.order ?? 9999)) // сортировка по order
      setLessons(lessonsData)
    })
    return () => unsub()
  }, [courseId])

  const downloadFile = (file) => {
    if (!file?.url) return
    window.open(file.url)
  }

  if (loading) return <p>Загрузка...</p>
  if (!course) return <p>Курс не найден</p>

  return (
    <>
      <Header />
      <h1>{course.title}</h1>
      <p>{course.description}</p>

      <h2>Уроки</h2>
      {lessons.length === 0 ? (
        <p>Уроков пока нет</p>
      ) : (
        <ul>
          {lessons.map((lesson, idx) => (
            <li key={lesson.id} className="lessons-free">
              <h3>
                Урок {idx + 1}: {lesson.title}
              </h3>
              {lesson.videoURL && (
                <a
                  href={lesson.videoURL}
                  target="_blank"
                  rel="noreferrer"
                  className="see-video-free"
                >
                  Смотреть видео
                </a>
              )}
              {lesson.files?.length > 0 && (
                <div className="lesson-files-container">
                  {lesson.files.map((file, i) => (
                    <div key={i} className="lesson-file-card">
                      <div className="file-icon">📄</div>
                      <div className="file-info">
                        <span className="file-name">{file.name}</span>
                        <button type="button" onClick={() => downloadFile(file)}>
                          Смотреть в файлах
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </li>
          ))}
        </ul>
      )}

      {course.testLink && (
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <h3>Tест после курса</h3>
          <a
            href={course.testLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '10px 20px',
              background: '#4CAF50',
              color: 'white',
              borderRadius: '8px',
              textDecoration: 'none',
            }}
          >
            Пройти тест
          </a>
        </div>
      )}
    </>
  )
}

export default FreeCourseDetails
